import type { FormattedTextParams, FormattedTextReturn, USPCardReturn } from './types';
import { renderRichText } from '@storyblok/js';
import type { ISbRichtext } from '@storyblok/js';

export function transformImage(image, option) {
  if (!image) return '';
  if (!option) return '';

  return `${image}/m/${option}`;
}

export function formatUSPCardTextContent(uspCardContent: FormattedTextParams): FormattedTextReturn {
  return {
    text: (uspCardContent as FormattedTextParams)?.text
      ? renderRichText((uspCardContent as FormattedTextParams).text as ISbRichtext)
      : '',
    fontWeight: uspCardContent?.fontWeight || { mobile: '400', tablet: '400', desktop: '400' },
    textAlign: uspCardContent?.textAlign || { mobile: 'left', tablet: 'left', desktop: 'left' },
    fontSize: uspCardContent?.fontSize || { mobile: '16', tablet: '16', desktop: '16' },
    module: 'SFormattedText'
  };
}
